import dashboard from "./dashboard/dashboard";
import depositRequest from "./deposit-request";
import notification from "./notification";
import order from "./order";
import refAffiliate from "./ref-affiliate";
import transaction from "./transaction";
import users from "./users";
import debt from "./debt";
import systemExchangeRate from "./system-exchange-rate";
const appsModule = {
  namespaced: false,
  modules: {
    users,
    notification,
    order,
    transaction,
    refAffiliate,
    depositRequest,
    dashboard,
    debt,
    systemExchangeRate,
  },
};

export default appsModule;
